import React, {Component} from 'react';
import Table from '../../../../../components/Table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MailFormModal from '../components/MailForm';
import MailDetailModal from '../components/MailDetailForm';
import DeleteMailModal from '../components/DeleteMailModal';
import {Modal} from "react-bootstrap";
import './styles.css'
import moment from 'moment'
import _ from "lodash";

class EmailBin extends Component {

    static contextTypes = {api: PropTypes.object};

    constructor(props){
        super(props);
        this.state = {
            editingMail:false,
            deletingMail:false,
            detailingMail:false,
            forwardingMail:false
        };
        this.loadData = _.debounce(this.loadData, 450);

    }

    loadData = ( tableState )=>{
        this.tableState = tableState;
        const filters = { ...tableState.filters, 'order[createdDate]':'DESC' };
        this.context.api.emailDocuments.get( tableState.page, tableState.pageSize, '@Class.emailDocuments.emailBin.get', filters )
    };

    onEditMail = (e)=>{
        e.stopPropagation();
        this.setState( {editingMail: e.currentTarget.dataset.index} )
    };

    closeEditMail = ()=> this.setState({editingMail:false});

    onDetailMail = (emailDocument)=> {this.setState( {detailingMail: emailDocument})};

    closeDetailMail = ()=> this.setState({detailingMail:false});

    onForwardMail = (e)=>{
        e.stopPropagation();
        this.setState( {forwardingMail: e.currentTarget.dataset.index} )
    };

    closeForwardMail = ()=>{
        this.loadData(this.tableState)
        this.setState({forwardingMail:false});
    };

    onDeleteMail = (e)=>{
        e.stopPropagation();
        this.setState( {deletingMail: e.currentTarget.dataset.index} )
    };

    deleteMail = ( mailId )=>{
        this.context.api.emailDocuments.delete( mailId)
            .then(()=>{
                this.loadData(this.tableState);
                this.closeDeleteMail();
            })
    };

    closeDeleteMail = ()=> this.setState({deletingMail:false});

    tableDefinition =
        [
            {
                name:'Acciones',
                accessor: ( document, index )=>{
                    if(!document.sentDate) return <span><button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteMail}><i className='ti-trash'/></button>&nbsp;<button className='btn btn-xs btn-primary' data-index={index} onClick = {this.onEditMail}><i className='ti-pencil'/></button></span>;
                    else return <span><button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteMail}><i className='ti-trash'/></button>&nbsp;<button className='btn btn-xs btn-warning' data-index={index} onClick = {this.onForwardMail}><i className='ti-back-right'/></button></span>
                 }
             }, {
                name:'Fecha de creación',
                id:'createdDate',
                accessor:(document)=>{ return moment(document.createdDate).format("DD/MM/YYYY") },
            }, {
                name:'Asunto',
                id:'subject',
                filterable:true,
                accessor:'subject'
            }, {
                name:'Estatus',
                id:'sentDate[exists]',
                filterable:true,
                filterComponent:( props )=>{
                    const onChange = (e)=>{
                        props.onChange(e.target.value);
                    };
                    return <select value={props.value} onChange={onChange} >
                        <option value=''>Todos</option>
                        <option value='true'>Enviados</option>
                        <option value='false'>Borradores</option>
                    </select>;
                },
                accessor:(document)=>{
                    if(!document.sentDate) return "Borrador";
                    else return "Enviado"
                }
            }
        ];

    render(){
        return(
            <div className="container-fluid EmailBin">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Lista de correos</h4>
                            </div>
                            <div className="card-content">
                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.emailDocumentsMeta.totalItems}
                                    data={this.props.emailDocuments}
                                    trProps = {(emailDocument)=>({onClick:()=>this.onDetailMail(emailDocument)})}
                                    loadData={this.loadData}
                                    columns={ this.tableDefinition }/>
                            </div>
                        </div>
                    </div>
                </div>
                {/*  Edit email Modal */}
                {this.state.editingMail?
                    <Modal className='mailModal'
                        show={true}
                        bsSize="large"
                        onHide={this.closeEditMail}>
                        <Modal.Header closeButton>
                            <Modal.Title>Edición de correo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <MailFormModal
                                onHide={this.closeEditMail}
                                editing = { this.props.emailDocuments[ this.state.editingMail ] }/>
                        </Modal.Body>
                    </Modal> :null}
                {/*  Detail email Modal */}
                {this.state.detailingMail?
                    <Modal className='mailModal'
                           show={true}
                           onHide={this.closeDetailMail}>
                        <Modal.Header closeButton>
                            <Modal.Title>Detalle de correo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <MailDetailModal
                                emailDocument={ this.state.detailingMail }
                                onHide={this.closeDetailMail}/>
                        </Modal.Body>
                    </Modal>:null}
                {/*  Forwarding email Modal */}
                {this.state.forwardingMail?
                    <Modal className='mailModal'
                           show={true}
                           bsSize="large"
                           onHide={this.closeForwardMail}>
                        <Modal.Header closeButton>
                            <Modal.Title>Reenviar correo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <MailFormModal
                                forwarding={this.props.emailDocuments[ this.state.forwardingMail ]}
                                emailDocument={ this.state.forwardingMail }
                                onHide={this.closeForwardMail}/>
                        </Modal.Body>
                    </Modal>:null}
                {/* Delete email Modal*/}
                {this.state.deletingMail?
                    <DeleteMailModal
                        emailDocument={ this.props.emailDocuments[ this.state.deletingMail ]}
                        onHide={this.closeDeleteMail}
                        onConfirm={this.deleteMail}/> :null}
            </div>
        );
    }
}

const mapStateToProps = ( { api: { emailDocuments=[], emailDocumentsMeta={} } } )=>{
    return {emailDocuments, emailDocumentsMeta}
};

export default connect(mapStateToProps)(EmailBin);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/EmailBin/index.jsx